import firebase from 'firebase/app'
import 'firebase/messaging'

// Initialize Firebase
export function initializeFirebase () {
  if (firebase.messaging.isSupported()) {
    if (!firebase.apps.length) {
      firebase.initializeApp(process.env.FIREBASE_CONFIG)
    }
  }
}

export function getFcmMessage () {
  return firebase.messaging()
}



// WEBPACK FOOTER //
// ./src/util/pushNotification.js